import { z } from 'zod'

export const MessageLogEntry = z.object({
  id: z.number(),
  direction: z.enum(['inbound', 'outbound']),
  sender: z.string(),
  recipients: z.array(z.string()),
  subject: z.string().optional(),
  domain: z.string(),
  size: z.number(),
  spam_result: z.enum(['pending', 'ham', 'spam', 'reject']),
  status: z.enum(['accepted', 'rejected', 'queued']),
  remote_ip: z.string().optional(),
  authenticated_as: z.string().optional(),
  timestamp: z.string()
})

export type MessageLogEntry = z.infer<typeof MessageLogEntry>

export const MessageLogResponse = z.object({
  messages: z.array(MessageLogEntry),
  total: z.number()
})

export type MessageLogResponse = z.infer<typeof MessageLogResponse>

export const TimelinePoint = z.object({
  timestamp: z.string(),
  inbound: z.number(),
  outbound: z.number(),
  spam: z.number()
})

export type TimelinePoint = z.infer<typeof TimelinePoint>

export const MessageStatsResponse = z.object({
  total_inbound: z.number(),
  total_outbound: z.number(),
  total_spam: z.number(),
  total_ham: z.number(),
  spam_rate: z.number(),
  timeline: z.array(TimelinePoint)
})

export type MessageStatsResponse = z.infer<typeof MessageStatsResponse>

export const AccountsSummaryResponse = z.object({
  total_accounts: z.number(),
  active_accounts: z.number(),
  total_quota_bytes: z.number(),
  total_used_bytes: z.number(),
  by_type: z.record(z.string(), z.number()),
  by_domain: z.record(z.string(), z.number())
})

export type AccountsSummaryResponse = z.infer<typeof AccountsSummaryResponse>
